import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { green, red } from '@mui/material/colors';
import AppWrappedCheckbox from '../../79/AppWrappedCheckbox';
import { fetchNpiData, fetchNpiDataByTN } from '../_api';
import { MESSAGE_BANNER_TYPES } from '_types';

const NPIVerification = ({
	id,
	formik,
	trackingNumber,
	lastName,
	firstName,
	value,
	...props
}) => {
	const [sMessage, setMessage] = useState(
		'The NPI registry could not verify the number provided. Please check to acknowledge the below information is accurate.',
	);
	const [sVerify, setVerify] = useState(false);
	const [sNpiTargetMetadata, setNpiTargetMetadata] = useState();

	useEffect(() => {
		let active = true;

		async function fetchApi() {
			const { messages, payload } = trackingNumber
				? await fetchNpiDataByTN(value, trackingNumber)
				: await fetchNpiData(value, lastName, firstName);
			if (
				messages?.length > 0 &&
				messages[0].Key === MESSAGE_BANNER_TYPES.ERROR
			) {
				setMessage(`${messages[0].Value} Please try again.`);
			} else if (
				messages?.length > 0 &&
				messages[0].Key === MESSAGE_BANNER_TYPES.WARNING
			) {
				setMessage(
					`${messages[0].Value} Please search another number.`,
				);
			} else {
				const { m_Item1, m_Item2 } = payload;
				setVerify(!m_Item1);
				setNpiTargetMetadata(m_Item2);
				if (!m_Item1) {
					setMessage(
						`The NPI number provided is valid but the name returned from the NPI Registry does not match UPMC's records. Please review the information from the NPI Registry below and confirm that it is correct.`,
					);
				} else {
					setMessage(
						'Please review the information from the NPI Registry below and confirm that it is correct.',
					);
				}
			}
		}

		if (active) {
			fetchApi();
		}

		return () => {
			active = false;
		};
	}, [trackingNumber, lastName, firstName, value]);

	const getInitials = (firstName, lastName) => {
		if (firstName && lastName) {
			const firstInitial = firstName[0].trim()[0];
			const secondInitial = lastName[0].trim()[0];
			return `${firstInitial}${secondInitial}`;
		}
	};

	return (
		<Box sx={{ pl: 10, pr: 10 }}>
			<AppWrappedCheckbox
				name={id}
				isRequired
				label={sMessage}
				formik={formik}
			/>
			{props.children}
			{sNpiTargetMetadata && (
				<Card>
					<CardHeader
						avatar={
							<Avatar
								sx={{
									bgcolor: sVerify ? red[500] : green[500],
								}}
								aria-label='recipe'
							>
								{getInitials(
									sNpiTargetMetadata?.basic?.first_name,
									sNpiTargetMetadata?.basic?.last_name,
								)}
							</Avatar>
						}
						title={`${sNpiTargetMetadata?.basic?.first_name} ${sNpiTargetMetadata?.basic?.last_name}`}
						subheader={`NPI: ${
							sNpiTargetMetadata?.number ?? 'N/A'
						}`}
					/>
					<CardContent>
						<Typography color='text.secondary'>
							Credential:{' '}
							{sNpiTargetMetadata?.basic?.credential ?? 'N/A'}
						</Typography>

						<Typography color='text.secondary'>
							Address:{' '}
							{sNpiTargetMetadata?.addresses
								? `${sNpiTargetMetadata?.addresses[0]?.address_1}, ${sNpiTargetMetadata?.addresses[0]?.city}, ${sNpiTargetMetadata.addresses[0].state} ${sNpiTargetMetadata.addresses[0].postal_code}`
								: 'N/A'}
						</Typography>
						<Typography color='text.secondary'>
							Telephone:{' '}
							{sNpiTargetMetadata?.addresses
								? sNpiTargetMetadata?.addresses[0]
										?.telephone_number
								: 'N/A'}
						</Typography>
					</CardContent>
				</Card>
			)}
		</Box>
	);
};
export default NPIVerification;
